<!--
 * @Author: your name
 * @Date: 2020-08-28 10:16:51
 * @LastEditTime: 2022-10-26 22:44:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\statisticalAnalysis\default.vue
-->
<template>
    <div class="statisticalAnalysis-default">
        <van-nav-bar
            title="统计分析"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="banner"></div>
        <div class="menus">
            <div class="row">
                <!--<div class="item item1" @click="toDayData">-->
                <!--     <div class="icon-con">-->
                <!--         <span class="icon"></span>-->
                <!--     </div>-->
                <!--     <p>每日数据</p>-->
                <!--</div>-->
                <div class="item item1" @click="toNewDayData">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>每日数据</p>
                </div>
                <div class="item item6" @click="toPlanTomorrow">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>明日计划</p>
                </div>
                <div class="item item2" @click="toSales">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>销售统计</p>
                </div>
                <div class="item item3" @click="toProductConsum">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>生产消耗</p>
                </div>
                <div class="item item4" v-if="$store.state.versionMark == 2" @click="toAccountsReceive">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>应收账款</p>
                </div>
                <div class="item item5" v-if="$store.state.versionMark == 2" @click="toPurchaseDaily">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>采购日报</p>
                </div>
                <div class="item item7" v-if="$store.state.versionMark == 2" @click="toMaterialCost">
                    <div class="icon-con">
                        <span class="icon"></span>
                    </div>
                    <p>材料成本</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ path: '/home' });
        },
        // 销售统计
        toSales() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'saleStatistical' });
        },
        // 消耗统计
        toProductConsum() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'productConsumIndex' });
        },
        // 采购日报
        toPurchaseDaily() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'purchaseDaily' });
        },
        // 每日数据
        toDayData() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'daydata' });
        },
        // 每日数据
        toNewDayData() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'newDaydata' });
        },
        // 应收账款
        toAccountsReceive() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'accountsReceive' });
        },
        // 明日计划
        toPlanTomorrow() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'planTomorrow' });
        },
        // 材料成本
        toMaterialCost() {
            this.$router.isBack = 2;
            this.$router.push({ name: 'materialCost' });
        },
    },
};
</script>
<style lang="stylus">
.statisticalAnalysis-default
    height 100%
    .iconsend
        background: linear-gradient(180deg, #EFAB54 0%, #FA8C47 100%);
        -webkit-background-clip text
        -webkit-text-fill-color transparent
    .banner
        height 184rpx
        background url(./images/bg.jpg) no-repeat
        background-size 100% 100%
    .menus
        padding 30rpx 0 30rpx 30rpx
        .row
            overflow hidden
            .item
                float left
                width 85rpx
                height 85rpx
                background url(./images/cxqk.png) no-repeat
                background-size 100% 100%
                margin-right 30rpx
                margin-bottom 30rpx
                cursor pointer
                .icon-con
                    text-align center
                    margin-top 10rpx
                    .icon
                        width 34rpx
                        height 34rpx
                        background-repeat no-repeat
                        background-size 100% 100%
                        display inline-block
                p
                    font-size 14rpx
                    text-align center
                &.item1
                    .icon
                        background-image url(./images/statistics_icon_1.png)
                &.item2
                    .icon
                        background-image url(./images/statistics_icon_2.png)
                &.item3
                    .icon
                        background-image url(./images/statistics_icon_3.png)
                &.item4
                    .icon
                        background-image url(./images/statistics_icon_4.png)
                &.item5
                    .icon
                        background-image url(./images/statistics_icon_5.png)
                &.item6
                    .icon
                        background-image url(./images/statistics_icon_6.png)
                &.item7
                    .icon
                        background-image url(./images/statistics_icon_7.png)
</style>
